// catalogoConfig.js
// Datos estáticos del catálogo: kits, ofertas, estructura de menú y colores.
// Para agregar un kit nuevo: copiar un bloque de KITS_VIRTUALES y ajustar los campos.
// Para agregar una oferta: agregar el codUru a PRODUCTOS_EN_OFERTA.

export const PRODUCTOS_EN_OFERTA = [
    "502028111",
    "502028112",
    "513000121",
    "513000131",
];

export const KITS_VIRTUALES = [
    {
        id: "KIT-S20 ANODIZADO",
        customerNo: "Kit Serie 20 Anodizado",
        descripcion: "Incluye: 1891(1), 1901(1), 1911(1), 1921(1), 1931(1)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 20",
        rama2: "Kit S20",
        color: "Anodizado",
        esKit: true,
        componentes: [
            { codigo: "502001891", cantidad: 1, desc: "Enganche central S20 Anod" },
            { codigo: "502001901", cantidad: 1, desc: "Zócalo S20 Anod" },
            { codigo: "502001911", cantidad: 1, desc: "Pierna S20 Anod" },
            { codigo: "502001921", cantidad: 1, desc: "Dintel S20 Anod" },
            { codigo: "502001931", cantidad: 1, desc: "Umbral S20 Anod" },
        ],
    },
    {
        id: "KIT-S20 Blanco",
        customerNo: "Kit Serie 20 Blanco",
        descripcion: "Incluye: 1894(1), 1904(1), 1914(1), 1924(1), 1934(1)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 20",
        rama2: "Kit S20",
        color: "Blanco",
        esKit: true,
        componentes: [
            { codigo: "502001894", cantidad: 1, desc: "Enganche central S20 Blanco" },
            { codigo: "502001904", cantidad: 1, desc: "Zócalo S20 Blanco" },
            { codigo: "502001914", cantidad: 1, desc: "Pierna S20 Blanco" },
            { codigo: "502001924", cantidad: 1, desc: "Dintel S20 Blanco" },
            { codigo: "502001934", cantidad: 1, desc: "Umbral S20 Blanco" },
        ],
    },
    {
        id: "KIT-S20 Anolok",
        customerNo: "Kit Serie 20 Anolok",
        descripcion: "Incluye: 1893(1), 1903(1), 1913(1), 1923(1), 1933(1)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 20",
        rama2: "Kit S20",
        color: "Anolok",
        esKit: true,
        componentes: [
            { codigo: "502001893", cantidad: 1, desc: "Enganche central S20 Anolok" },
            { codigo: "502001903", cantidad: 1, desc: "Zócalo S20 Anolok" },
            { codigo: "502001913", cantidad: 1, desc: "Pierna S20 Anolok" },
            { codigo: "502001923", cantidad: 1, desc: "Dintel S20 Anolok" },
            { codigo: "502001933", cantidad: 1, desc: "Umbral S20 Anolok" },
        ],
    },
    {
        id: "KIT-S20 Madera",
        customerNo: "Kit Serie 20 Madera",
        descripcion: "Incluye: 1892(1), 1902(1), 1912(1), 1922(1), 1932(1)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 20",
        rama2: "Kit S20",
        color: "Madera",
        esKit: true,
        componentes: [
            { codigo: "502001892", cantidad: 1, desc: "Enganche central S20 Madera" },
            { codigo: "502001902", cantidad: 1, desc: "Zócalo S20 Madera" },
            { codigo: "502001912", cantidad: 1, desc: "Pierna S20 Madera" },
            { codigo: "502001922", cantidad: 1, desc: "Dintel S20 Madera" },
            { codigo: "502001932", cantidad: 1, desc: "Umbral S20 Madera" },
        ],
    },
    {
        id: "KIT-S25 Anodizado",
        customerNo: "Kit Serie 25 Anodizado",
        descripcion: "Incluye: 2500(1), 2501(1), 2528(1), 4503(1), 4504(1), 4505(1), 4507(1)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 25",
        rama2: "Kit S25",
        color: "Anodizado",
        esKit: true,
        componentes: [
            { codigo: "502525001", cantidad: 1, desc: "Marco Inferior S25 Anodizado" },
            { codigo: "502525011", cantidad: 1, desc: "Marco Lateral S25 Anodizado" },
            { codigo: "502525281", cantidad: 1, desc: "Marco Superior S25 Anodizado" },
            { codigo: "502545031", cantidad: 1, desc: "Zocalo Hoja S25 Anodizado" },
            { codigo: "502545041", cantidad: 1, desc: "Dintel Hoja S25 Anodizado" },
            { codigo: "502545051", cantidad: 1, desc: "Lateral Hoja S25 Anodizado" },
            { codigo: "502545071", cantidad: 1, desc: "Enganche Central S25 Anodizado" },
        ],
    },
    {
        id: "KIT-S25 Madera",
        customerNo: "Kit Serie 25 Madera",
        descripcion: "Incluye: 2500(2), 2501(2), 2528(2), 4503(2), 4504(2), 4505(2), 4507(2)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 25",
        rama2: "Kit S25",
        color: "Madera",
        esKit: true,
        componentes: [
            { codigo: "502525002", cantidad: 1, desc: "Marco Inferior S25 Madera" },
            { codigo: "502525012", cantidad: 1, desc: "Marco Lateral S25 Madera" },
            { codigo: "502525282", cantidad: 1, desc: "Marco Superior S25 Madera" },
            { codigo: "502545032", cantidad: 1, desc: "Zocalo Hoja S25 Madera" },
            { codigo: "502545042", cantidad: 1, desc: "Dintel Hoja S25 Madera" },
            { codigo: "502545052", cantidad: 1, desc: "Lateral Hoja S25 Madera" },
            { codigo: "502545072", cantidad: 1, desc: "Enganche Central S25 Madera" },
        ],
    },
    {
        id: "KIT-S25 Anolok",
        customerNo: "Kit Serie 25 Anolok",
        descripcion: "Incluye: 2500(3), 2501(3), 2528(3), 4503(3), 4504(3), 4505(3), 4507(3)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 25",
        rama2: "Kit S25",
        color: "Anolok",
        esKit: true,
        componentes: [
            { codigo: "502525003", cantidad: 1, desc: "Marco Inferior S25 Anolok" },
            { codigo: "502525013", cantidad: 1, desc: "Marco Lateral S25 Anolok" },
            { codigo: "502525283", cantidad: 1, desc: "Marco Superior S25 Anolok" },
            { codigo: "502545033", cantidad: 1, desc: "Zocalo Hoja S25 Anolok" },
            { codigo: "502545043", cantidad: 1, desc: "Dintel Hoja S25 Anolok" },
            { codigo: "502545053", cantidad: 1, desc: "Lateral Hoja S25 Anolok" },
            { codigo: "502545073", cantidad: 1, desc: "Enganche Central S25 Anolok" },
        ],
    },
    {
        id: "KIT-S25 Blanco",
        customerNo: "Kit Serie 25 Blanco",
        descripcion: "Incluye: 2500(4), 2501(4), 2528(4), 4503(4), 4504(4), 4505(4), 4507(4)",
        padre: "Perfiles Aluminio",
        rama1: "Serie 25",
        rama2: "Kit S25",
        color: "Blanco",
        esKit: true,
        componentes: [
            { codigo: "502525004", cantidad: 1, desc: "Marco Inferior S25 Blanco" },
            { codigo: "502525014", cantidad: 1, desc: "Marco Lateral S25 Blanco" },
            { codigo: "502525284", cantidad: 1, desc: "Marco Superior S25 Blanco" },
            { codigo: "502545034", cantidad: 1, desc: "Zocalo Hoja S25 Blanco" },
            { codigo: "502545044", cantidad: 1, desc: "Dintel Hoja S25 Blanco" },
            { codigo: "502545054", cantidad: 1, desc: "Lateral Hoja S25 Blanco" },
            { codigo: "502545074", cantidad: 1, desc: "Enganche Central S25 Blanco" },
        ],
    },
];

export const MENU_ESTRUCTURA = [
    { nombre: "🔥 Ofertas", subcategorias: [] },
    {
        nombre: "Perfiles Aluminio",
        subcategorias: [
            { nombre: "Serie 20", colores: ["Anodizado", "Blanco", "Madera", "Anolok", "Sin Acabado"] },
            { nombre: "Serie 25", colores: ["Anodizado", "Blanco", "Madera", "Anolok"] },
            { nombre: "Puerta / Serie 30", colores: ["Anodizado", "Blanco", "Madera", "Anolok", "Sin Anodizar"] },
            { nombre: "Americana", colores: ["Anodizado", "Kit"] },
            { nombre: "Mampara", colores: ["Anodizado", "Blanco", "Anolok", "Madera"] },
            { nombre: "Angulo", colores: ["Anodizado", "Blanco", "Anolok"] },
            { nombre: "Tubo", colores: ["Anodizado", "Blanco", "Anolok", "Madera", "Small"] },
            { nombre: "Perfil U", colores: ["Anodizado", "Blanco", "Anolok"] },
            { nombre: "Baranda", colores: ["Anodizado"] },
        ],
    },
    {
        nombre: "Accesorio Aluminio",
        subcategorias: [
            { nombre: "Kit", colores: [] },
            { nombre: "Bisagra", colores: [] },
            { nombre: "Burlete", colores: [] },
            { nombre: "Cerraduras, Cierres y Manijas", colores: [] },
            { nombre: "Felpa", colores: [] },
            { nombre: "Rodamiento", colores: [] },
            { nombre: "Varios", colores: [] },
            { nombre: "Insumos DVH", colores: [] },
            { nombre: "Plasticos", colores: [] },
            { nombre: "Tejido Mosquitero", colores: [] },
        ],
    },
    {
        nombre: "Accesorio PVC",
        subcategorias: [
            { nombre: "50 LIK", colores: [] },
            { nombre: "Bayindir", colores: [] },
            { nombre: "50 LIK / Bayindir", colores: [] },
        ],
    },
    {
        nombre: "Chapa de aluminio",
        subcategorias: [
            { nombre: "Lisa", colores: [] },
            { nombre: "Antideslizante", colores: [] },
        ],
    },
    {
        nombre: "Perfiles PVC",
        subcategorias: [
            { nombre: "Bayindir", colores: ["Blanco", "Negro", "Madera", "Antracita"] },
            { nombre: "50 LIK", colores: ["Blanco", "Negro", "Madera", "Antracita"] },
            { nombre: "50 LIK / Bayindir", colores: ["Blanco", "Negro", "Madera", "Antracita"] },
            { nombre: "Refuerzo", colores: [] },
        ],
    },
    {
        nombre: "Vidrio",
        subcategorias: [
            { nombre: "Laminados", colores: [] },
            { nombre: "Float", colores: [] },
        ],
    },
];

export const MAPA_COLORES = {
    Anodizado: "#b5babe",
    Blanco: "#ffffff",
    Anolok: "#2c2c2c",
    Madera: "#8b5a2b",
    Natural: "#d1d5d8",
    Negro: "#1a1a1a",
};
